import styled, { css, keyframes } from 'styled-components';
const keyframesCircularRotate = keyframes`
100%{
transform: rotate(360deg);
}
`;
export const CircularProgressWrapper = styled.div`
  animation: ${keyframesCircularRotate} 1.4s linear infinite;
  display: inline-block;
  color: ${props => {
  switch (props.color) {
    case 'primary':
      return '#3f51b5';

    case 'secondary':
      return '#f50057';

    case 'inherit':
      return 'inherit';
  }
}};
`;
export const SVGWrapper = styled.svg`
  display: block;
`;
const keyframesCircularDash = keyframes`
0%{
  stroke-dasharray: 1px, 200px;
  stroke-dashoffset: 0px;
}
50%{
  stroke-dasharray: 100px, 200px;
  stroke-dashoffset: -15px;
}
100%{
  stroke-dasharray: 100px, 200px;
  stroke-dashoffset: -125px;
}
`;
export const CircleWrapper = styled.circle`
  stroke: currentColor;
  stroke-dashoffset: 0px;
  stroke-dasharray: 80px, 200px;
  animation: ${props => props.disableShrink ? 'unset' : css`
          ${keyframesCircularDash} 1.4s ease-in-out infinite
        `};
`;